module.exports = __webpack_public_path__ + "static/assets/4b52903ed5677ad3e0b820668ddb37c9.svg";